import { storefrontAll, storefrontConfig, storefrontConfigDefault } from '@graphcommerce/next-ui'

export function defaultLocale(): string {
  return storefrontConfigDefault().locale
}

export function localeToStore(locale?: string | null | undefined) {
  if (!locale) return storefrontConfigDefault().magentoStoreCode
  return storefrontConfig(locale)?.magentoStoreCode
}

export function storeToLocale(store?: string | null | undefined) {
  // Add patch:
  // we need to exclude the default locale,
  // because this would return the default magentoStoreCode locale as a url dynamic route.
  // In which case this would return 'deault' and next can not resolve this route and returns an empty string in the url
  // https://nextjs.org/docs/pages/building-your-application/routing/internationalization#transition-between-locales
  return storefrontAll.find((l) => l.locale !== 'default' && l.magentoStoreCode === store)?.locale
}
